import type { MichiganTimezone, CurrentWeather } from '@miweather/shared';

export function getTimezoneAbbrev(timezone: MichiganTimezone): string {
  return timezone === 'America/Chicago' ? 'CT' : 'ET';
}

export function calcDewPoint(current: CurrentWeather): number | null {
  if (current.temperature === null) return null;
  const tempC = (current.temperature - 32) * 5 / 9;
  const dewC = tempC - ((100 - current.humidity) / 5);
  return Math.round((dewC * 9 / 5) + 32);
}
